import {
  SET_PRODUCT_BRANDS,
  SET_PRODUCT_BRANDS_IS_LOADING,
  SET_SINGLE_PRODUCT_BRAND_IS_LOADING,
  SET_SINGLE_PRODUCT_BRAND,
  CLEAR_SINGLE_PRODUCT_BRAND
} from './constants';

const defaultState = {
  isSingleProductBrandLoading: false,
  list: [],
  total: 0,
  isLoading: false,
  submit: {
    id: null,
    name: '',
    description: ''
  }
}

export default (state = defaultState, action) => {
  switch(action.type) {
    case SET_PRODUCT_BRANDS: {
      return {
        ...state,
        list: action.data,
        total: action.data?.length
      }
    }
    case SET_PRODUCT_BRANDS_IS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading
      }
    }
    case SET_SINGLE_PRODUCT_BRAND_IS_LOADING: {
      return {
        ...state,
        isSingleProductBrandLoading: action.isLoading
      }
    }
    case SET_SINGLE_PRODUCT_BRAND: {
      const {
        id,
        name,
        description
      } = action.data;

      return {
        ...state,
        submit: {
          id,
          name,
          description
        }
      }
    }
    case CLEAR_SINGLE_PRODUCT_BRAND: {
      return {
        ...state,
        submit: defaultState.submit
      }
    }
    default: {
      return state;
    }
  }
}